import React from "react";
import { Parallax } from "react-scroll-parallax";
import { FaPuzzlePiece, FaHeart, FaUsers, FaHandHoldingHeart } from "react-icons/fa";
import "./Mission.css";

import pictureOne from "../../assets/mission1.webp";
import pictureTwo from "../../assets/mission2.webp";
import pictureThree from "../../assets/mission3.webp";

import kidDandelion from "../../assets/kidDandelion.webp";
import kidSlide from "../../assets/kidSlideWide.webp";

function Mission() {
    const missionVideo = "https://firebasestorage.googleapis.com/v0/b/binkley-preschool-website.firebasestorage.app/o/binkleyvid12.mp4?alt=media&token=76e0e7bb-983d-42ee-8a7a-ee44ef59e85e"

  return (
    <div className="mission-page">
      {/* Tagline */}
      <Parallax speed={-10}>
        <section className="mission-hero">
            <video className="hero-video" autoPlay loop muted playsInline>
            <source src={missionVideo} type="video/mp4" />
            Your browser does not support the video tag.
            </video>

            {/* Dark overlay */}
            <div className="hero-overlay"></div>

            {/* Text content */}
            <div className="mission-hero-content">
            <h1>Binkley Preschool's Mission</h1>
            <p>
                As a nonprofit, community-based preschool, we are dedicated to fostering a love of learning, promoting social-emotional development, and preparing children for future academic success.
            </p>
            </div>
        </section>
</Parallax>
{/* <section className="divider-section"></section> */}


{/* Core Values */}
<Parallax speed={5}>
  <section className="mission-values">
    <h2>What We Value:</h2>
    <div className="values-cards">
      <div className="value-card">
        <FaPuzzlePiece className="value-icon" />
        <h3>Play-Based Learning</h3>
        <p>We believe that children learn best through hands-on exploration and imaginative play.</p>
      </div>
      <div className="value-card">
        <FaHeart className="value-icon" />
        <h3>Whole-Child Development</h3>
        <p>Supporting social, emotional, physical, and cognitive growth.</p>
      </div>
      <div className="value-card">
        <FaUsers className="value-icon" />
        <h3>Community & Belonging</h3>
        <p>Celebrating diversity, kindness, and respect for all.</p>
      </div>
      <div className="value-card">
        <FaHandHoldingHeart className="value-icon" />
        <h3>Family Partnership</h3>
        <p>Collaborating closely with parents and caregivers to support each child’s journey.</p>
      </div>
    </div>
  </section>
</Parallax>

      
<section className="mission-and-values">
  <Parallax speed={-5}>
    <div className="mission-vision">
      <h2>Binkley's Vision</h2>
      <p>We envision a preschool where every child feels safe, inspired, and empowered to explore the world. Our goal is to spark curiosity, compassion, and confidence that will last a lifetime.</p>
    </div>
  </Parallax>

  <Parallax speed={3}>
    <div className="mission-image">
      <img src={kidDandelion} alt="Child blowing dandelion" />
    </div>
  </Parallax>

  <Parallax speed={-3}>
    <div className="mission-image-two">
      <img src={kidSlide} alt="Child coming down slide" />
    </div>
  </Parallax>

  <Parallax speed={5}>
    <div className="mission-statement">
      <h2>Mission Statement</h2>
      <p>Binkley Preschool believes that all children regardless of ethnic, cultural, or socio-economic backgrounds, deserve a high-quality preschool experience. At Binkley Preschool, we believe that children should be allowed to be children. We foster a loving, nurturing, play-based environment that is challenging and
      stimulating, but not frustrating. Our goal is to give children a solid foundation upon which to build their education.</p>
    </div>
  </Parallax>
</section>


        {/* Pictures */}    
      <section className="picture-section">
        <img
            src={pictureOne}
            alt="children playing together"
            className="mission-picture"
        />
        <img
            src={pictureTwo}
            alt="Children playing together"
            className="mission-picture"
        />
        <img
            src={pictureThree}
            alt="Children playing together"
            className="mission-picture"
        />
        </section>

    </div>
  );
}

export default Mission;
